import { ClearFilterAction } from '@faire/web-api--source/indigofair/data/ClearFilterAction';
import { IAssignSettingAction } from '@faire/web-api--source/indigofair/data/IAssignSettingAction';
import { IDismissAction } from '@faire/web-api--source/indigofair/data/IDismissAction';
import { ILoggingAction } from '@faire/web-api--source/indigofair/data/ILoggingAction';
import { INavigateAction } from '@faire/web-api--source/indigofair/data/INavigateAction';
import { IOpenModalAction } from '@faire/web-api--source/indigofair/data/IOpenModalAction';
import { IRecordCategoryNodesVisibilityAction } from '@faire/web-api--source/indigofair/data/IRecordCategoryNodesVisibilityAction';
import { IRecordMilestoneAction } from '@faire/web-api--source/indigofair/data/IRecordMilestoneAction';
import { IScrollAction } from '@faire/web-api--source/indigofair/data/IScrollAction';

export namespace IAction {
  /**
   * Return an instance of IAction with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IAction>): IAction =>
    ({
      ...(partial ?? {}),
    }) as IAction;
}

export interface IAction {
  navigate: INavigateAction | undefined;
  assign_setting: IAssignSettingAction | undefined;
  record_milestone: IRecordMilestoneAction | undefined;
  /**
   * For usage of customized PETE event logging.
   */
  log_event: ILoggingAction | undefined;
  open_modal: IOpenModalAction | undefined;
  record_category_nodes_visibility:
    | IRecordCategoryNodesVisibilityAction
    | undefined;
  dismiss: IDismissAction | undefined;
  /**
   * For clearing selected filters on cat nav pages
   */
  clear_filter: ClearFilterAction | undefined;
  scroll_action: IScrollAction | undefined;
}
